export default "__VITE_ASSET__DovK9TEi__"